import { IIconBase } from '..'

const successModalIcon = ({
  color = '#198754',
  height = 40,
  width = 41,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 41 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/tick-circle'>
        <g id='tick-circle'>
          <path
            id='Vector'
            d='M20.4997 36.6673C29.6663 36.6673 37.1663 29.1673 37.1663 20.0007C37.1663 10.834 29.6663 3.33398 20.4997 3.33398C11.333 3.33398 3.83301 10.834 3.83301 20.0007C3.83301 29.1673 11.333 36.6673 20.4997 36.6673Z'
            stroke={color}
            strokeWidth='2.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M13.417 19.9999L18.1337 24.7165L27.5837 15.2832'
            stroke={color}
            strokeWidth='2.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}

export default successModalIcon
